/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from './vuetify'
import pinia from '../stores'
import router from '../router'

// Custom plugins
import SimpleAlert from './simple-alert'
import SimpleLoading from './simple-loading'
import DialogAlert from './dialog-alert'
import Tooltip from './tooltip'

// Types
import type { App } from 'vue'

// prettier-ignore
export function registerPlugins (app: App) {
  app
    .use(vuetify)
    .use(SimpleAlert, {})
    .use(SimpleLoading)
    .use(DialogAlert)
    .use(Tooltip)
    .use(router)
    .use(pinia)
}
